import { Form, Grid, useForm, SIZE, Stack, Text } from '@quinyx/ui';
import * as z from 'zod';

import { IZoined, IZoinedExtended } from '../../api/interfaces/customer';
import { useTranslate } from '../../hooks/translate';

type ZoinedProps = {
  initialValues?: IZoinedExtended;
  onSubmit: (zoined: IZoined) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

const schema = z.object({
  zoinedCustomerId: z.string().min(1),
  zoinedSecret: z.string().min(1),
});

const ZoinedForm = ({
  initialValues,
  onSubmit,
  isLoading = false,
  isDisabled = false,
}: ZoinedProps) => {
  const { t } = useTranslate();
  const formMethods = useForm({
    defaultValues: initialValues,
    schema,
  });

  return (
    <Form methods={formMethods} onSubmit={onSubmit}>
      <Stack spacing={SIZE.L}>
        <Text variant="smallRegular" color="SurfaceOnSurfaceAlt">
          {t('zoined.description')}
        </Text>
        <Grid columns={[1, 1, 1, 2]} gap={SIZE.M}>
          <Form.TextInput
            name="zoinedCustomerId"
            label={t('zoined.customerId')}
            required
            disabled={isDisabled}
          />
          <Form.TextInput
            name="zoinedSecret"
            label={t('zoined.secretKey')}
            required
            disabled={isDisabled}
          />
        </Grid>

        <Stack alignItems="flex-end">
          <Form.SubmitButton
            text={t('zoined.updateConfig')}
            isLoading={isLoading}
            disabled={isDisabled}
          />
        </Stack>
      </Stack>
    </Form>
  );
};

export default ZoinedForm;
